export interface OpeningHourWebEntity {
    day: number
    fromTime: string
    toTime: string
    isEnabled: boolean
  }